import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
} from "react";
import { DefaultCard } from "../../assets/styled-components/card";
import {
    Typography,
    Grid,
    TextField,
} from "@mui/material";
import CustomBarChart from "../commoncomponents/CustomBarChart";
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,

    Tooltip,
    Legend,
} from 'chart.js';
import reportslogo from "../../assets/images/reportslogo.png";
import "../commoncomponents/print.css"; // Import the print CSS
import "jspdf-autotable";
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);
// Register the components from chart.js
ChartJS.register(
    LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend
);

const QualityPPM = forwardRef((props, ref) => {
    const { report, reportdata, year, service, month, department, setText, text, date, setDate } = props;

    const handleText = (field, value) => {
        setDate((prev) => ({ ...prev, [field]: value }));
    };

    const printRef = useRef(null);



    const labels = ['', '', '', ''];
    const dataValues = [];

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Total Number of Breakdowns',
                data: dataValues,
                fill: false,
                backgroundColor: 'none',
                borderColor: 'none',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                ticks: {
                    display: false,
                },
                grid: {
                    drawBorder: false,
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Total Number of Breakdown',
                    color: 'black',
                    font: {
                        size: 15,
                        weight: 'bold',
                    },
                    padding: { top: 5, bottom: 5 },
                },
                border: {
                    display: true,
                    color: 'black',

                },
            },

            y: {
                ticks: {
                    display: false,
                    stepSize: 0,
                    callback: function (value) {
                        return value.toFixed(2);
                    },
                },
                min: 0,
                max: 0.1050,
                grid: {
                    drawBorder: false,
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Number of Breakdown',
                    color: 'black',
                    font: {
                        size: 15,
                        weight: 'bold',
                    },
                    padding: { top: 5, bottom: 5 },
                },
                border: {
                    color: 'black',
                    height: 100
                },
            },


        },

    };



    const convertPercentageToNumber = (percentStr) => {
        return parseFloat(percentStr) || 0;
    };

    const chartData = {
        labels: [
            `1/${year}`, `2/${year}`, `3/${year}`, `4/${year}`, `5/${year}`,
            `6/${year}`, `7/${year}`, `8/${year}`, `9/${year}`, `10/${year}`,
            `11/${year}`, `12/${year}`
        ],
        datasets: [
            {
                label: 'Percentage Completed (%)',
                data: [
                    convertPercentageToNumber(reportdata?.perJan), // Ensure you convert each value
                    convertPercentageToNumber(reportdata?.perFeb),
                    convertPercentageToNumber(reportdata?.perMarch),
                    convertPercentageToNumber(reportdata?.perApril),
                    convertPercentageToNumber(reportdata?.perMay),
                    convertPercentageToNumber(reportdata?.perJune),
                    convertPercentageToNumber(reportdata?.perJuly),
                    convertPercentageToNumber(reportdata?.perAugust),
                    convertPercentageToNumber(reportdata?.perSept),
                    convertPercentageToNumber(reportdata?.perOct),
                    convertPercentageToNumber(reportdata?.perNov),
                    convertPercentageToNumber(reportdata?.perDec),
                ],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {

                    generateLabels: (chart) => [
                        { text: 'January', fillStyle: '#0000FF' },
                        { text: 'February', fillStyle: '#FF0000' },
                        { text: 'March', fillStyle: '#00FF00' },
                        { text: 'April', fillStyle: '#800080' },
                        { text: 'May', fillStyle: '#00FFFF' },
                        { text: 'June', fillStyle: '#ADD8E6' },
                        { text: 'July', fillStyle: '#FFC0CB' },
                        { text: 'August', fillStyle: '#FFFF00' },
                        { text: 'September', fillStyle: '#E0FFFF' },
                        { text: 'October', fillStyle: '#FFA500' },
                        { text: 'November', fillStyle: '#006400' },
                        { text: 'December', fillStyle: '#00008B' }
                    ],
                },
            },
            title: {
                display: true,
                text: `Percentage of Planned Preventive Maintenance for ${month} ${year}`,
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.raw}%`;
                    },
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    callback: function (value) {
                        return `${value}%`;
                    },
                },
                title: {
                    display: true,
                    text: 'Percentage',
                },
            },
        },
    };

    const otherSetting = {
        height: 400,
        width: 1100,
        yAxis: [
            {
                label: "Total Work Orders",
            },
        ],
        grid: { horizontal: true },
        margin: { bottom: 200 },
    };


    return (

        <div
            ref={printRef}
            style={{
                padding: "20px",
                fontFamily: "Arial, sans-serif",
                maxWidth: "900px",
                margin: "0 auto",
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <div className="logo" style={{ marginRight: '16px' }}>
                    <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px' }} />
                </div>
            </div>
            <div style={{ textAlign: "center", marginBottom: "20px", fontFamily: "Arial Narrow", fontSize: '18px' }}>
                <h2>
                    ANALYSIS REPORT FOR DEPARTMENTAL QUALITY OBJECTIVE (PERFORMANCE INDICATORS)
                </h2>
            </div>
            <br></br>
            {/* Report Details Table */}
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                }}
            >
                <tbody>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>STANDARD</strong></td>

                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>MSQH / STANDARD 03</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>DEPARTMENT</strong></td>
                        {/* Check if department exists, and if not, display a default value or placeholder */}
                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>
                            {department ? department : "All"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>UNIT</strong></td>
                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>{service}</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>MONTH/YEAR</strong></td>
                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>{month}/{year}</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>DESCRIPTION</strong></td>
                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>
                            PERCENTAGE OF PLAN PREVENTIVE MAINTENANCE BEING DONE ON SCHEDULE
                        </td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '18px', fontFamily: 'Times New Roman' }}><strong>TARGET </strong> </td>
                        <td style={{ fontSize: '17px', fontFamily: 'Times New Roman' }}>98%</td>
                    </tr>
                </tbody>
            </table>
            <br></br>
            <br></br>
            {/* Rationale Section */}

            <h3 style={{ marginRight: '2px', fontSize: '18px', fontFamily: 'Times New Roman' }}>A. Rationale</h3> {/* Adjust marginRight value as needed */}
            <br></br>
            <ul style={{ marginleft: '15px', fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>
                <li>
                    Planned preventive maintenance of facilities and equipment in a hospital is an important component of Facility Management to provide safe patient care.
                </li>
                <li>
                    Without regular maintenance there will be likelihood of increasing demands for high-cost maintenance elements such as building services, re-roofing, or structural repairs. Therefore, it is financially advantageous, if not essential, to have a Planned Preventive Maintenance (PPM) schedule. A PPM schedule can ensure that routine maintenance and repair works are implemented to ease out peaks and troughs in the annual maintenance cost cycle of buildings and equipment and ensure safe patient care without interruptions to life-saving procedures.
                </li>
            </ul>
            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '1px' }}>Long-term benefits of preventive maintenance include:</p>
            <ol style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>
                <li>Improved system reliability</li>
                <li>Reduced replacement costs</li>
                <li>Decreased system downtime</li>
                <li>Better spares inventory management</li>
            </ol>
            <br></br>
            <br></br>
            <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>B.Definition of Term</h3>
            <br></br>
            <strong><li style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '15px' }}> Planned Preventive Maintenance (PPM) </li></strong>

            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>
                Planned Preventive Maintenance (PPM) is regular repetitive work done to keep facilities and equipment in good working order and to optimize its efficiency and accuracy.
                {/* <br></br> */}
                <br></br>
                The Dates and scope of tasks are defined as Time based maintenance plans of Performance based maintenance plans or Performance based maintenance plans.
            </p>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>C. Inclusive Criteria</h3>
            <br></br>
            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>
                All facilities and equipment needing PPM as per
                manufacturers'/contractors' specifications.
            </p>
            <br></br>
            <br></br>
            <br></br>
            <br></br>


            <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>D. Exclusion Criteria</h3>
            <br></br>
            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>N/A</p>
            <br></br>
            <br></br>
         



            <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>E. Type of Indicator</h3>
            <br></br>
            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>This is a rate based on a process indicator.</p>

            <br></br>
            <br></br>
            <br></br>

            <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>F. Methodology</h3>
            <br></br>
            <p style={{ fontSize: '17px', fontFamily: 'Times New Roman', marginLeft: '35px' }}>
                Data were collected based on PPM service reports of equipment and
                building systems.
            </p>
            <br></br>

            {/* Formula Section */}
            {/* <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '900px', margin: '0 auto' }}> */}
            <p style={{ marginRight: '1px', fontSize: '17px', fontFamily: 'Times New Roman' }}>Planned Preventive Maintenance (PPM) is calculated using the following formula:</p>
            <br></br>
            <table cellPadding="5" style={{ width: '100%', textAlign: 'left', fontSize: '16px' }}>
                <tbody>
                    <tr>
                        <td style={{ fontSize: '15px' }}>Numerator :</td>
                        <td style={{ fontSize: '15px' }}> Number of asset undergone planned preventive maintenance</td>
                        <td rowSpan="2" style={{ textAlign: 'center', fontSize: '15px' }}>X 100</td>
                    </tr>
                    <tr>
                        <td style={{ fontSize: '15px' }}>Denominator:</td>
                        <td style={{ fontSize: '15px' }}> Number of asset scheduled for planned preventive maintenance</td>
                    </tr>
                </tbody>
            </table>
            {/* </div> */}
            <section className="results-table">
                <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%', fontSize: '14px' }}>
                    <thead>
                        <tr style={{ border: '1px solid black', textAlign: 'center', fontSize: '16px', padding: '8px' }}>
                            <th colSpan={15} style={{ border: '1px solid black' }}> {year}</th>
                        </tr>
                        <tr style={{ border: '1px solid black', textAlign: 'center', padding: '8px' }}>
                            <th style={{ border: '1px solid black', padding: '5px' }} colSpan={2}></th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>1/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>2/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>3/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>4/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>5/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>6/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>7/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>8/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>9/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>10/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>11/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>12/{year}</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ border: '1px solid black', textAlign: 'center' }}>
                            <td style={{ border: '1px solid black', padding: '10px' }}>Numerator</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>Number of asset undergone planned preventive maintenance</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuJan || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuFeb || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuMarch || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuApril || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuMay || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuJune || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuJuly || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuAugust || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuSept || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuOct || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuNov || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuDec || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.nuTotal || "0"}</td>
                        </tr>
                        <tr style={{ border: '1px solid black', textAlign: 'center' }}>
                            <td style={{ border: '1px solid black', padding: '10px' }}>Denominator</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>Number of asset scheduled for planned preventive maintenance</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deJan || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deFeb || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deMarch || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deApril || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deMay || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deJune || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deJuly || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deAugust || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deSept || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deOct || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deNov || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deDec || "0"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.deTotal || "0"}</td>
                        </tr>
                        <tr className="result-row" style={{ border: '1px solid black', textAlign: 'center' }}>
                            <th colSpan={15} style={{ border: '1px solid black', padding: '10px' }}>X 100</th>
                        </tr>
                        <tr className="result-row" style={{ border: '1px solid black', textAlign: 'center' }}>
                            <td style={{ border: '1px solid black', padding: '10px' }}></td>
                            <td style={{ border: '1px solid black', padding: '10px' }}><strong>Percentage Completed %</strong></td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perJan || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perFeb || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perMarch || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perApril || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perMay || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perJune || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perJuly || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perAugust || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perSept || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perOct || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perNov || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perDec || "0%"}</td>
                            <td style={{ border: '1px solid black', padding: '10px' }}>{reportdata?.perTotal || "0%"}</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <DefaultCard>

                <Typography variant="h4" sx={{ fontSize: '18px', fontFamily: 'Times New Roman', fontWeight: 'bold' }}>TREND CHART {year} :</Typography>

                <Bar data={chartData} options={chartOptions} />

            </DefaultCard>

            <br></br>
            {/* <Box sx={{ padding: '20px' }}> */}
            <div style={{ marginBottom: "20px" }}>
                <h3 style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman' }}>
                    Location Analysis
                </h3>
                <p style={{ marginRight: '1px', fontSize: '18px', fontFamily: 'Times New Roman', marginLeft: '45px' }}>
                    Location analysis done according to number of breakdown in each department for this month. Department with most breakdown will be looked in detail whether it is human error, machine error or ' wear and tear ' parts.
                </p>
            </div>
            <br>
            </br>
            <br>
            </br>
            {/* <DefaultCard width='1100px'> */}
            <div style={{ width: otherSetting.width, height: otherSetting.height }}>
                {report && Array.isArray(report) && report.length > 0 ? (
                    <CustomBarChart
                        dataset={report}
                        xDataKey="locationName" // Ensure these keys exist in your data
                        yDataKey="graphcount"
                        label="Total WO Numbers"
                        otherSetting={otherSetting}
                        verticalLabels={true}
                    />
                ) : (
                    <div
                    className="no-break"
                    style={{
                        width: '850px', 
                        height: '450px', 
                        border: '1px solid black',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                        display: 'block',
                    }}
                >
                    <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '20px' }}>
                        LOCATION OF BREAKDOWN
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'block',
                            height: '324px',
                            width: '1500px',
                        }}
                    >
                        <Line data={data} options={options} />
                    </div>
                </div>
                )}
            </div>
            {/* </DefaultCard> */}


            <br></br>
            <br></br>
            <br></br>
            <br></br>
            {/* Text Sections for Analysis, Action Taken, and Recommendation */}
            <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
                <Grid item xs={12}>
                    <h4 style={{ marginRight: '1px', fontSize: '15px', fontFamily: 'Times New Roman' }}>Analysis:</h4>
                    <br></br>
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        value={date.analysis}
                        onInput={(e) => handleText("analysis", e.target.value)}
                        
                    />
                </Grid>
                <Grid item xs={12}>
                    <h4 style={{ marginRight: '1px', fontSize: '15px', fontFamily: 'Times New Roman' }}>Action Taken:</h4>
                    <br></br>
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        value={date.actiontaken}
                        onInput={(e) => handleText("actiontaken", e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <br></br>
                    <h4 style={{ marginRight: '1px', fontSize: '15px', fontFamily: 'Times New Roman' }}>Recommendation:</h4>
                    <br></br>
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        value={date.recommendation}
                        onInput={(e) => handleText("recommendation", e.target.value)}
                    />
                </Grid>
            </Grid>
            <br></br>
            <table style={{ width: '100%', height: '220px', borderCollapse: 'collapse', textAlign: 'center', border: '1px solid black' }}>
                <thead>
                    <tr style={{ border: '1px solid black' }}>
                        <th style={{ border: '1px solid black', padding: '5px' }}>Reported by:</th>
                        <th style={{ border: '1px solid black', padding: '5px' }}>Reviewed and Approved by:</th>

                    </tr>
                </thead>
                <tbody>
                    {/* <tr style={{ border: '1px solid black' }}>
                                                          <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                              <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                          </td>
                                                          <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                              <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                          </td>
                                                       
                                                      </tr> */}
                    <tr style={{ border: '1px solid black' }}>
                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ marginBottom: '10px', padding: '5px', height: '40px' }}>
                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.names}
                                        onInput={(e) => handleText("names", e.target.value)} />
                                </div>

                                <div>
                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designations}
                                        onInput={(e) => handleText("designations", e.target.value)} />
                                </div>
                            </div>
                        </td>
                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ marginBottom: '5px' }}>
                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.name}
                                        onInput={(e) => handleText("name", e.target.value)} />
                                </div>
                                <br></br>
                                <div>
                                    <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                    <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designation} onInput={(e) => handleText("designation", e.target.value)} />
                                </div>
                            </div>
                        </td>

                    </tr>
                    <tr style={{ border: "1px solid black" }}>
                        {["date", "dates"].map((key) => (
                            <td key={key} style={{ border: "1px solid black", padding: "10px", textAlign: "left" }}>
                                <label style={{ marginRight: "3px", fontWeight: "bold", fontSize: "15px" }}>Date:</label>
                                <input
                                    type="text"
                                    style={{ border: "none", outline: "none", width: "50%" }}
                                    value={date[key]}
                                    onChange={(e) => {
                                        let inputValue = e.target.value;

                                        // Allow only numbers and slashes (/), removing any invalid characters
                                        let sanitizedValue = inputValue.replace(/[^0-9/]/g, "");

                                        // Ensure partial valid format (DD/MM/YYYY or partial valid input)
                                        if (/^\d{0,2}\/?\d{0,2}\/?\d{0,4}$/.test(sanitizedValue)) {
                                            handleText(key, sanitizedValue);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        let inputValue = e.target.value;

                                        // Only clear if the input is completely invalid, otherwise keep it
                                        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(inputValue) && inputValue.length > 0) {
                                            handleText(key, inputValue); // Keep input if partially valid
                                        }
                                    }}
                                    maxLength={10}
                                />
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>



        </div>
    );
}
);

export default QualityPPM;
